// extracted by mini-css-extract-plugin
export default {"card":"VerifiedCard_card__2XJAh","documentPhoto":"VerifiedCard_documentPhoto__T-w6l","light-mode":"VerifiedCard_light-mode__UGp3D","downloadIcon":"VerifiedCard_downloadIcon__a82XM"};